import { render, staticRenderFns } from "./PagePublications.vue?vue&type=template&id=c136beba&"
import script from "./PagePublications.vue?vue&type=script&lang=js&"
export * from "./PagePublications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports